import * as React from 'react'

import { Box, List, Skeleton } from '@factorialco/deprecated-design-system'
import { times } from 'lodash'

export const FileListSkeleton = ({ count = 3 }) => {
  return (
    <List>
      {times(count, (index) => (
        <List.Item key={`file-list-skeleton-${index}`}>
          <List.Title>
            <Box flexDirection="row" gap="s8">
              <Skeleton width="s40" height="s40" />
              <Box gap="s8">
                <Skeleton width="s80" height="s12" />
                <Skeleton width="s200" height="s12" />
              </Box>
            </Box>
          </List.Title>

          <List.ActionItem>
            <Box flexDirection="row" gap="s8">
              <Skeleton width="s32" height="s32" />
              <Skeleton width="s32" height="s32" />
            </Box>
          </List.ActionItem>
        </List.Item>
      ))}
    </List>
  )
}
